<template >
    <div class="analysis">
        <div class="analysis-top">
            <div class="tit">机构分析</div>
            <div class="txt">本平台基于近二十年中医药高等院校、中医药学者发表的中医学学科的期刊、会议及学位论文.本平台基于近二十年中医药高等院校、中医药学者发表的中医学学科的期刊、会议及学位论文本平台基于近二十年中医药高等院校、中医药学者发表的中医学学科的期刊、会议及学位论文...</div>
        </div>
        <div class="analysis-content">
            <div class="cont-info">
                <div class="info-tit">重点学科服务 </div>
                <ul class="info-subject">
                    <li class="subject-item" v-for="(item,index) in subjectList" :key="index">
                        <div class="item-tit">{{ item.tit }}</div>
                    </li>
                </ul>
            </div>
            <div class="cont-info">
                <div class="info-tit">专家学者分析 </div>
                <ul class="info-expert"> 
                    <li class="expert-card" v-for="(item,index) in expertList" :key="index"> 
                        <div class="card-img">
                            <!-- 使用稳定高清且主题相关的人物图片（视觉自然）picsum 提供高质量图片 -->
                            <el-image :src="item.img" width="100%" fit="cover" />
                        </div>
                        <div class="card-info">
                            <div class="card-name">{{ item.tit }}</div>
                            <!-- <div class="card-role">{{ item.role }}</div> -->
                            <div class="card-desc">{{ item.txt }}</div>
                            <el-button type="primary" round  plain >查看详情 →</el-button>
                        </div> 
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            subjectList: [
                { tit: '中医基础理论' },
                { tit: '内经学' },
                { tit: '伤寒学' },
                { tit: '中医诊断学' },
                { tit: '方剂学' },
                { tit: '中医体质学' },
                { tit: '中医循证医学' },
                { tit: '中医护理学' },
                { tit: '中医儿科学' },
                { tit: '中医男科学' },
                { tit: '中医脑病学' },
                { tit: '中医肺病学' },
                { tit: '中医内分泌病学' },
                { tit: '中药学' },
                { tit: '中医药信息学' },
            ],
            expertList: [
                {
                    tit: '周维桢',
                    role: '教授 / 人工智能研究院院长',
                    txt: 'IEEE Fellow，主导研发多模态大模型及AI for Science，获中国计算机学会王选奖。',
                    img: require('../../assets/images/home/subject-pic2.png'),
                },
                {
                    tit: '张三',
                    role: '教授 / 博士生导师',
                    txt: '长期从事中医基础理论与临床研究工作，主持多项国家级科研项目。',
                    img: require('../../assets/images/home/subject-pic2.png'),
                },
                {
                    tit: '李四',
                    role: '研究员 / 学科带头人',
                    txt: '专注于方剂学与现代药理学交叉研究，发表高水平论文多篇。',
                    img: require('../../assets/images/home/subject-pic2.png'),
                },
                {
                    tit: '王五',
                    role: '教授 / 中医诊断学专家',
                    txt: '在中医诊断标准化与证候研究方面具有丰富经验与学术影响力。',
                    img: require('../../assets/images/home/subject-pic2.png'),
                },
            ],
        }
    }
}
</script>
<style lang="less" scoped>
.analysis{ 
    
    .analysis-top{
        background: url('../../assets/images/home/banner-bg.png') no-repeat top center;
        background-size: cover;
        width: 100%;
        min-width: 1200px ;
        margin: 0px auto;
        padding: 40px 0;
        color: #fff;
        font-weight: bold;
        .tit{ 
            text-align: center;
            font-size: 24px;    
            margin-bottom: 10px;
        }
        .txt{
            width: 1200px;
            margin: 0 auto; 
            font-size: 16px; 
            line-height: 32px;
        }
    }
    .analysis-content{
        width: 1200px;
        margin: 0 auto;
        padding: 20px 0;
        .cont-info{
            margin-bottom: 40px;
            .info-tit{ 
                justify-content: center;
                font-size: 20px;
                font-weight: bold; 
                text-align: center; 
                padding-bottom: 10px; 
                color: #000;
                padding: 10px 0 30px 0;
            }
        }
        .info-subject{
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 20px;
            .subject-item{
                background: #fff;
                padding: 16px;
                border-radius: 8px;
                text-align: center;
                font-size: 16px;
                font-weight: bold;
                color: #000; 
                cursor: pointer;
                border: 1px solid #e4e7ed;
                &:hover{
                    border: 1px solid #396de7;
                    color: #396de7;
                    box-shadow: 0px 2px 16px 8px rgba(22,93,255,0.04);
                }
            }
        }
        .info-expert{
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 24px;
            .expert-card{
                background: #ffffff;
                border-radius: 20px; 
                text-align: center;
                overflow: hidden;
                transition: all 0.2s ease;
                border: 1px solid #e9eef5;
                box-shadow: 0 2px 4px rgba(0,0,0,0.02);
                cursor: pointer; 
                &:hover{
                    border-color: #396de7;
                    background: #ffffff;
                    transform: translateY(-3px);
                    box-shadow: 0 12px 20px -12px rgba(57, 109, 231, 0.2);
                }
                .card-img{
                    width: 100%;
                    height: 200px;
                    ::v-deep .el-image{
                        width: 100%;
                        height: 100%;
                    }
                }
                .card-info{ 
                    padding: 16px 20px 20px;
                }
                .card-name{
                    font-size: 22px;
                    font-weight: bold;
                    color: #1d2129;
                    line-height: 1.4;
                } 
                .card-desc{
                    font-size: 14px;
                    color: #4e5969;
                    line-height: 24px;
                    height: 120px;
                    margin:10px 0;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 5;
                    -webkit-box-orient: vertical;
                } 
            }
        }
    }
}
</style>